import { useEffect, useState } from 'react';
import { format } from 'date-fns';

import { createException, GeneralErrors } from '@labradorsports/utils';

import { useLogger } from '../../providers/index.js';

export interface Props {
    date: Date | number | string;
    pattern: string;
    className?: string;
    /** Renders nothing until after the client mounts, to avoid SSR/client hydration mismatches (e.g. timezone-dependent formatting) */
    deferToClient?: boolean;
}

const SafeDateFormat: FC<Props> = ({ date, pattern, className, deferToClient }) => {
    const logger = useLogger();
    const [mounted, setMounted] = useState(!deferToClient);

    useEffect(() => {
        if (deferToClient) {
            setMounted(true);
        }
    }, [deferToClient]);

    const formatSafely = () => {
        try {
            return format(date instanceof Date ? date : new Date(date), pattern);
        } catch (error) {
            logger.error(
                createException(GeneralErrors.UNKNOWN_ERROR, {
                    details: `Failed to format ${date} to ${pattern}`,
                    nestedError: error,
                })
            );

            return null;
        }
    };

    const formatted = mounted ? formatSafely() : null;

    return className || deferToClient ? (
        <span className={['safe-date-format', className].filter(Boolean).join(' ')}>{formatted}</span>
    ) : (
        formatted
    );
};

export default SafeDateFormat;
